import React, { useState } from "react";
import {
  Box,
  List,
  ListItem,
  Divider,
  Button,
  Collapse,
  IconButton,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { SideDrawerStyles } from "../../Styles/styles";
import {
  DashboardIcon,
  EventsIcon,
  EventsManagementIcon,
  ExploreIcon,
  SettingsIcon,
} from "../../Svg/icons";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import QuickTixLogo from "../../Images/GX_Logo_White_No_Bg.png";

import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";

const SideDrawer = ({
  userRole,
  handleListItemClick,
  setMobileOpen,
  mobileOpen,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openTicketsMenu, setOpenTicketsMenu] = useState(false);

  let menuItems = [];
  switch (userRole) {
    case "commonUser":
      menuItems = [
        {
          text: "Explore Events",
          icon: <ExploreIcon />,
          path: "/explore-events",
        },
        { text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
        {
          text: "Create Events/Tickets",
          icon: <EventsManagementIcon />,
          path: "/eventmanagement",
        },
        {
          text: "Scan Tickets",
          icon: <DocumentScannerIcon />,
          path: "/QRCode-upload",
        },
        {
          text: "My Tickets",
          icon: <BookmarkBorderOutlinedIcon sx={{ fontSize: 25 }} />,
          path: "/mytickets",
        },
        { text: "Event Invites", icon: <EventsIcon />, path: "/eventinvites" },
        { text: "Settings", icon: <SettingsIcon />, path: "/settings" },
      ];
      break;
    default:
      menuItems = [];
  }

  const handleClick = (path) => {
    handleListItemClick(path);
    navigate(path);
    setMobileOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    navigate("/login");
    window.location.reload();
  };

  return (
    <Box
      sx={{
        ...SideDrawerStyles.SideDrawerBox1,
        zIndex: 1000,
        position: "relative",
      }}
    >
      <Box>
        <Link to="/">
          <Box sx={SideDrawerStyles.SideDrawerBox2}>
            <img
              src={QuickTixLogo}
              alt="GX Tickets"
              style={{ height: "85px" }}
            />
          </Box>
        </Link>
        <List sx={{ whiteSpace: "nowrap" }}>
          {menuItems.map((item) => (
            <React.Fragment key={item.text}>
              <ListItem disablePadding sx={{ padding: "10px 0px" }}>
                <Button
                  fullWidth
                  startIcon={item.icon}
                  onClick={() => handleClick(item.path)}
                  sx={{
                    fontWeight: 600,
                    fontSize: "16px",
                    justifyContent: "flex-start",
                    padding: "12px",
                    textTransform: "none",
                    backgroundColor:
                      location.pathname === item.path
                        ? "#535353"
                        : "transparent",
                    color: location.pathname === item.path ? "white" : "white",
                    "&:hover": {
                      backgroundColor: "var(--secondary-color)",
                      color: "white",
                    },
                  }}
                >
                  {item.text}
                  {item.submenu && (
                    <IconButton
                      sx={{ p: 0, pl: "5px" }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents triggering the parent button click
                        setOpenTicketsMenu(!openTicketsMenu);
                      }}
                    >
                      {openTicketsMenu ? (
                        <ExpandLess sx={{ fontSize: 20, color: "white" }} />
                      ) : (
                        <ExpandMore sx={{ fontSize: 20, color: "white" }} />
                      )}
                    </IconButton>
                  )}
                </Button>
              </ListItem>
              {item.submenu && (
                <Collapse in={openTicketsMenu} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.submenu.map((subItem) => (
                      <ListItem key={subItem.text} sx={{ paddingLeft: 4 }}>
                        <Button
                          startIcon={subItem.icon}
                          fullWidth
                          onClick={() => handleClick(subItem.path)}
                          sx={{
                            fontWeight: 500,
                            fontSize: "14px",
                            padding: "8px 14px",
                            justifyContent: "flex-start",
                            textTransform: "none",
                            color:
                              location.pathname === subItem.path
                                ? "white"
                                : "#ccc",
                            backgroundColor:
                              location.pathname === subItem.path
                                ? "#535353"
                                : "transparent",
                            "&:hover": {
                              backgroundColor: "var(--secondary-color)",
                              color: "white",
                            },
                          }}
                        >
                          {subItem.text}
                        </Button>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ))}
        </List>
      </Box>
      <Box>
        <Divider sx={SideDrawerStyles.DividerStyles} />
        <List>
          <ListItem key="Logout" disablePadding sx={{ padding: "12px" }}>
            <Button
              fullWidth
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                padding: "10px 20px",
                textTransform: "none",
                backgroundColor:
                  location.pathname === "/logout" ? "#2E728F" : "white",
                color: location.pathname === "/logout" ? "white" : "black",
                "&:hover": {
                  backgroundColor: "var(--secondary-color)",
                  color: "white",
                },
              }}
            >
              Log out
            </Button>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};

export default SideDrawer;
